import React from 'react';

type DsaModalProps = {
  isOpen: boolean;
  onClose: () => void;
  product?: {
    title: string;
    organisationName: string;
  };
};

export function DsaModal({ isOpen, onClose, product }: DsaModalProps) {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '16px',
        overflowY: 'auto'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '600px',
          width: '100%',
          marginTop: '40px',
          marginBottom: '40px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: '24px',
            borderBottom: '1px solid #E5E5E5',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: '24px',
              fontWeight: 600,
              color: '#1B1B1F'
            }}
          >
            Om denne annonsen
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '0',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#1B1B1F'
            }}
            aria-label="Lukk"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          {/* Advertiser section */}
          <div style={{ marginBottom: '32px' }}>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                marginBottom: '12px',
                color: '#1B1B1F'
              }}
            >
              Annonsør
            </h3>
            <p style={{ margin: 0, color: '#474445', fontSize: '16px' }}>
              {product?.organisationName || 'N/A'}
            </p>
          </div>

          <div
            style={{
              height: '1px',
              backgroundColor: '#E5E5E5',
              marginBottom: '32px'
            }}
          />

          {/* Product section */}
          <div style={{ marginBottom: '32px' }}>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                marginBottom: '12px',
                color: '#1B1B1F'
              }}
            >
              Produkt
            </h3>
            <p style={{ margin: 0, color: '#474445', fontSize: '16px' }}>
              {product?.title || 'N/A'}
            </p>
          </div>

          <div
            style={{
              height: '1px',
              backgroundColor: '#E5E5E5',
              marginBottom: '32px'
            }}
          />

          {/* Why this ad section */}
          <div style={{ marginBottom: '32px' }}>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                marginBottom: '12px',
                color: '#1B1B1F'
              }}
            >
              Hvorfor ser jeg denne annonsen?
            </h3>
            <p style={{ margin: 0, color: '#474445', fontSize: '16px' }}>
              Denne annonsen vises basert på din nettleseraktivitet og
              interesser. Annonsøren har valgt å markedsføre dette produktet til
              brukere som deg.
            </p>
          </div>

          <div
            style={{
              height: '1px',
              backgroundColor: '#E5E5E5',
              marginBottom: '32px'
            }}
          />

          {/* Paid by section */}
          <div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                marginBottom: '12px',
                color: '#1B1B1F'
              }}
            >
              Betalt av
            </h3>
            <p style={{ margin: 0, color: '#474445', fontSize: '16px' }}>
              {product?.organisationName || 'N/A'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
